import swal from "sweetalert";

export const ShowSwal = (status, msg) => {
  const message = msg ?? "Something went wrong!";
  swal(status ? "Success" : "Failed", message, status ? "success" : "error");
};

export const ShowInfoSwal = (msg) => {
  swal("Info", msg, "info");
};
